export const coolcatsNFTs = [
  {
    id: 'coolcat-9967',
    name: 'Cool Cats #9967',
    image: 'https://ipfs.io/ipfs/QmYFag7t4K6xQARUpdNkdYyBg8n6YGck9MFXQyJZUys5LZ',
    price: '0.82 ETH'
  },
  {
    id: 'coolcat-9966',
    name: 'Cool Cats #9966',
    image: 'https://ipfs.io/ipfs/QmfM8XHMtELiQXwqFKTC6JWXKRyjaCESfrMZEbXVofvuUc',
    price: '0.65 ETH'
  },
  {
    id: 'coolcat-9965',
    name: 'Cool Cats #9965',
    image: 'https://ipfs.io/ipfs/QmTNwNatMSBU9ArcV1DMUAGMqeAmnY8Akf6vPXmdZA4gqE',
    price: '0.93 ETH'
  },
  {
    id: 'coolcat-9964',
    name: 'Cool Cats #9964',
    image: 'https://ipfs.io/ipfs/QmTPnZnQpHeFMWQeAP8UoN6ETCtQ9VtG2PrbnVi9B8KZHg',
    price: '0.71 ETH'
  },
  {
    id: 'coolcat-9963',
    name: 'Cool Cats #9963',
    image: 'https://ipfs.io/ipfs/QmeeC1MsoMFiPqwrmRC88MJ3ZBbs5ze4fvVoBKJfL6TgsS',
    price: '0.48 ETH'
  },
  {
    id: 'coolcat-9962',
    name: 'Cool Cats #9962',
    image: 'https://ipfs.io/ipfs/QmTEiqyfTAJ3TgvrUWPXejBcMJSCgo6mLgoZSNo1Fzg3kx',
    price: '1.00 ETH'
  },
  {
    id: 'coolcat-9961',
    name: 'Cool Cats #9961',
    image: 'https://ipfs.io/ipfs/QmYMim9RhVuWboy9PKaVfKgtGaPJJW46DtcENxtG1hB8wW',
    price: '0.88 ETH'
  },
  {
    id: 'coolcat-9959',
    name: 'Cool Cats #9959',
    image: 'https://ipfs.io/ipfs/QmQLAXZd5sjNEzGNnUEPsEXQM6hYXTJv9CMRG5fFvntUhg',
    price: '0.76 ETH'
  },
  {
    id: 'coolcat-9958',
    name: 'Cool Cats #9958',
    image: 'https://ipfs.io/ipfs/QmNxARHUe1sJ4TNKeaJgPyBdTVPdpHtg7fg6dmU3UXFgR7',
    price: '0.95 ETH'
  },
    

  {
    id: 'coolcat-9957',
    name: 'Cool Cats #9957',
    image: 'https://ipfs.io/ipfs/QmPoRxdCFZYfCH4vqzzPTQfowS1BAmg47mTP8MLaJvCTUH',
    price: '0.67 ETH'
  },
  {
    id: 'coolcat-9956',
    name: 'Cool Cats #9956',
    image: 'https://ipfs.io/ipfs/QmaTeFTiHRExBCWwgdcHZ2QGufY8MSEPiUicmPXJPY8vqc',
    price: '0.89 ETH'
  },
  {
    id: 'coolcat-9955',
    name: 'Cool Cats #9955',
    image: 'https://ipfs.io/ipfs/QmcsQg42kNWSn9hqYAVfxwyhm8EmZSVNe7xAYmrHF4HcSb',
    price: '0.52 ETH'
  },
  {
    id: 'coolcat-9954',
    name: 'Cool Cats #9954',
    image: 'https://ipfs.io/ipfs/QmaHEtG6QayMCSWKi1kqce7Tb3BPPVFmezbR8woDiVPS9J',
    price: '0.98 ETH'
  },
  {
    id: 'coolcat-9953',
    name: 'Cool Cats #9953',
    image: 'https://ipfs.io/ipfs/QmNnWJnrCCJ4SgHuSPSfsW3g6knbULBsV3QKZXXss8P1GN',
    price: '0.73 ETH'
  },
  {
    id: 'coolcat-9952',
    name: 'Cool Cats #9952',
    image: 'https://ipfs.io/ipfs/Qmad87dBsu9xMMr6aQhKaWSjdKchrotMJ4WguJbffjEKY6',
    price: '0.85 ETH'
  },
  {
    id: 'coolcat-9951',
    name: 'Cool Cats #9951',
    image: 'https://ipfs.io/ipfs/QmUR52Tnb6DZX83He3gwyjgDbKRXdaDPA6DV72GQx6QRJb',
    price: '0.61 ETH'
  },
  {
    id: 'coolcat-9950',
    name: 'Cool Cats #9950',
    image: 'https://ipfs.io/ipfs/QmdcKDBVY8xgdZou8vUXxdaZdErgj92bkPEnJFyjzkYNGm',
    price: '0.94 ETH'
  },
  {
    id: 'coolcat-9949',
    name: 'Cool Cats #9949',
    image: 'https://ipfs.io/ipfs/QmS9aieLQLsfmNZktw6mLKrx9bshb4up6qrrLTCDPntPe7',
    price: '0.48 ETH'
  },
  {
    id: 'coolcat-9948',
    name: 'Cool Cats #9948',
    image: 'https://ipfs.io/ipfs/QmYk7an6K5sZ3iA66xYumM7KU8pdnQc213rq4QCMXd9YGz',
    price: '0.77 ETH'
  },
  {
    id: 'coolcat-9947',
    name: 'Cool Cats #9947',
    image: 'https://ipfs.io/ipfs/QmaY6LpcxDvbTcP6Ew5ssJCuEnHnk5x9BMNGrqJXoZMFdB',
    price: '0.92 ETH'
  },
  {
    id: 'coolcat-9946',
    name: 'Cool Cats #9946',
    image: 'https://ipfs.io/ipfs/QmSzR3NmT7uZrA32GyJKpNNfxoRmndcS7m3U1vRhA8c3wf',
    price: '0.56 ETH'
  },
  {
    id: 'coolcat-9945',
    name: 'Cool Cats #9945',
    image: 'https://ipfs.io/ipfs/QmXEqcPJomFRECJQsYGLciWKgdBNW2PcC43nybdN66vtXt',
    price: '0.83 ETH'
  },
  {
    id: 'coolcat-9944',
    name: 'Cool Cats #9944',
    image: 'https://ipfs.io/ipfs/QmbeG7NbqE35ZrexkFMqQMwYcaWZsvaeWnzQx3KVwZk56J',
    price: '0.69 ETH'
  },
  {
    id: 'coolcat-9943',
    name: 'Cool Cats #9943',
    image: 'https://ipfs.io/ipfs/QmTT6MqVDNDu1XxLnqQj1w94hpr74EybYB8LDutjQ2Xdv2',
    price: '0.99 ETH'
  },
  {
    id: 'coolcat-9942',
    name: 'Cool Cats #9942',
    image: 'https://ipfs.io/ipfs/QmbxUygCQwvSkQHMkJ66D5JrLJ6ZvFmwzFX7xFiP17Lz4y',
    price: '0.51 ETH'
  },
  {
    id: 'coolcat-9941',
    name: 'Cool Cats #9941',
    image: 'https://ipfs.io/ipfs/QmWWNL1a3dWu61dqtF2ijcWYFNUsqHajHd7Nf9UUgRfTBn',
    price: '0.87 ETH'
  },
  {
    id: 'coolcat-9940',
    name: 'Cool Cats #9940',
    image: 'https://ipfs.io/ipfs/QmQrkcVigNbfjRg4abG4v38mxwiG89oSj9CVmpvWPiKxDK',
    price: '0.64 ETH'
  },
  {
    id: 'coolcat-9939',
    name: 'Cool Cats #9939',
    image: 'https://ipfs.io/ipfs/QmfU3W34i8UEJt6gDm5h62CkD69VJKmvT4ipGJLLWJLWsB',
    price: '0.96 ETH'
  },
  {
    id: 'coolcat-9938',
    name: 'Cool Cats #9938',
    image: 'https://ipfs.io/ipfs/QmXztCuxcLLiKgNL9Yfsgynte9a4iQV82MBqm7bMcudpzf',
    price: '0.58 ETH'
  },
  {
    id: 'coolcat-9937',
    name: 'Cool Cats #9937',
    image: 'https://ipfs.io/ipfs/Qmbrot1gfTKf7Uxi2swPPm6ctAnej9wxGyUWsaqUZ8KjKB',
    price: '0.81 ETH'
  },
  {
    id: 'coolcat-9936',
    name: 'Cool Cats #9936',
    image: 'https://ipfs.io/ipfs/QmUDtAWgj6gTRB5vmvGwAfQ3HKU5epRQD1z98ZCqPdN1pH',
    price: '0.75 ETH'
  },
  {
    id: 'coolcat-9935',
    name: 'Cool Cats #9935',
    image: 'https://ipfs.io/ipfs/QmctjXwRrbgHYo4fF7EKnhsGCNDeeyo1SWRHhBUZAWpVZq',
    price: '1.00 ETH'
  },
  {
    id: 'coolcat-9934',
    name: 'Cool Cats #9934',
    image: 'https://ipfs.io/ipfs/QmXya8aFyDpYmVx9V6HHFzKHXyUozmeMVgQBiArBTmXvRT',
    price: '0.54 ETH'
  },
  {
    id: 'coolcat-9933',
    name: 'Cool Cats #9933',
    image: 'https://ipfs.io/ipfs/QmSBphevBkQdAPj1W5Nnr7yzrvSyLckJVPYbvJBqYLR7Kd',
    price: '0.91 ETH'
  },
  {
    id: 'coolcat-9932',
    name: 'Cool Cats #9932',
    image: 'https://ipfs.io/ipfs/QmWPt1xN7TPuFKgXCoYbMSuz26uxxBfgLGDAsHYD3V2Ncb',
    price: '0.63 ETH'
  },
  {
    id: 'coolcat-9931',
    name: 'Cool Cats #9931',
    image: 'https://ipfs.io/ipfs/QmarPFzo4UGAuHsZqaNASQX3KRmA9ynqdNDPxqLSQvJcnd',
    price: '0.86 ETH'
  },
  {
    id: 'coolcat-9930',
    name: 'Cool Cats #9930',
    image: 'https://ipfs.io/ipfs/QmSWZkhETDZUr7Wmf3jpnvmN46pfJmjdGNM4Rfkd9rKLar',
    price: '0.72 ETH'
  },
  {
    id: 'coolcat-9929',
    name: 'Cool Cats #9929',
    image: 'https://ipfs.io/ipfs/QmVrYtmxpF5C5VFMz7AKtyMn79NFBgKCLkWoHYc2koP7gx',
    price: '0.97 ETH'
  },
  {
    id: 'coolcat-9928',
    name: 'Cool Cats #9928',
    image: 'https://ipfs.io/ipfs/QmUUyhN5FgRJ4HUihnQPMEcynemvXvGkFoDKPypzGxZmDL',
    price: '0.49 ETH'
  },
  {
    id: 'coolcat-9927',
    name: 'Cool Cats #9927',
    image: 'https://ipfs.io/ipfs/QmV1q1yvxPFyigfszZt1HbgaHVGnasGQrFFFjG85LDJoAu',
    price: '0.84 ETH'
  },
  {
    id: 'coolcat-9926',
    name: 'Cool Cats #9926',
    image: 'https://ipfs.io/ipfs/QmNg1xnn6RkvQAUP8RTZbychW64Z8o89Ejamz2jhXVKikx',
    price: '0.68 ETH'
  },
  {
    id: 'coolcat-9925',
    name: 'Cool Cats #9925',
    image: 'https://ipfs.io/ipfs/QmS5E7NJpsA5CSJDDhJ6WpnEWpVyPVTawVaunfcGcPCgkz',
    price: '0.93 ETH'
  },
  {
    id: 'coolcat-9924',
    name: 'Cool Cats #9924',
    image: 'https://ipfs.io/ipfs/QmU3vX7fDfYXzd2tVxLNKxk339nuEUEciirwD8TWsmk8hg',
    price: '0.57 ETH'
  },
  {
    id: 'coolcat-9923',
    name: 'Cool Cats #9923',
    image: 'https://ipfs.io/ipfs/QmTyBkdG2C7dq7Amx3hUP6MEDtUAWNjibqGxwx23MhVgmf',
    price: '0.88 ETH'
  },
  {
    id: 'coolcat-9922',
    name: 'Cool Cats #9922',
    image: 'https://ipfs.io/ipfs/QmR7U8h4oVmpZvKhC1MQfh4aNHD2vXfArSy8rtb76MUycm',
    price: '0.66 ETH'
  },
    
  {
    id: 'coolcat-9921',
    name: 'Cool Cats #9921',
    image: 'https://ipfs.io/ipfs/QmPQDN2ULif8yhHcSp6m5Vfvkzutc1p5hmxmYNSLDteRRH',
    price: '0.95 ETH'
  },
  {
    id: 'coolcat-9920',
    name: 'Cool Cats #9920',
    image: 'https://ipfs.io/ipfs/QmeG3tc2wjcrs42Ewr3GXgomQ1gX4NveVZzUEwbZrfEzSi',
    price: '0.62 ETH'
  },
  {
    id: 'coolcat-9919',
    name: 'Cool Cats #9919',
    image: 'https://ipfs.io/ipfs/QmXo3jbr6jyDAziqPCge1L6dUVuQbajo9rmAw3Hw3ebjsX',
    price: '0.89 ETH'
  },
  {
    id: 'coolcat-9918',
    name: 'Cool Cats #9918',
    image: 'https://ipfs.io/ipfs/QmYyEYzD1M9TFJ1NUnmuBHB89g5v4fDfCoBGVSzYvbX3NZ',
    price: '0.53 ETH'
  },
  {
    id: 'coolcat-9917',
    name: 'Cool Cats #9917',
    image: 'https://ipfs.io/ipfs/QmQE8DQJrPegrfzaFyMRugkmbC8fCFzrrD49Mmb9KN8cFE',
    price: '0.78 ETH'
  },
  {
    id: 'coolcat-9916',
    name: 'Cool Cats #9916',
    image: 'https://ipfs.io/ipfs/QmUgSucqJvExJzXBzkUHyHSZK18a1qrB7MH5mepaA65c9A',
    price: '0.99 ETH'
  },
  {
    id: 'coolcat-9915',
    name: 'Cool Cats #9915',
    image: 'https://ipfs.io/ipfs/QmaL3NQnXWYWfhPNBhn1eFEUsrbrhYfdtvQXck2dTyWsEb',
    price: '0.67 ETH'
  },
  {
    id: 'coolcat-9914',
    name: 'Cool Cats #9914',
    image: 'https://ipfs.io/ipfs/QmRq1DkEQRCkLzZe6jwutNpWEmRvAvjyphxzJLcoZAHdhs',
    price: '0.85 ETH'
  },
  {
    id: 'coolcat-9913',
    name: 'Cool Cats #9913',
    image: 'https://ipfs.io/ipfs/QmUDUFZZwZxXkGNKbqr2Yhyw91RKo8vkMTYFGn3jtMhMdk',
    price: '0.72 ETH'
  },
  {
    id: 'coolcat-9912',
    name: 'Cool Cats #9912',
    image: 'https://ipfs.io/ipfs/QmYjHXZjpPTL6DGN29h1eP7FYbrHjmRD9EwwZkm2C38vjU',
    price: '0.94 ETH'
  },
  {
    id: 'coolcat-9911',
    name: 'Cool Cats #9911',
    image: 'https://ipfs.io/ipfs/QmdhDxJdSnRJwg31sPTkHEMT1PmMxGc75k4MYgu5yg7sBh',
    price: '0.58 ETH'
  },
  {
    id: 'coolcat-9910',
    name: 'Cool Cats #9910',
    image: 'https://ipfs.io/ipfs/QmYdgRGwnRkwPYMareTRjLWSVZzY4LLKRchUpy9TtSTEhS',
    price: '0.81 ETH'
  },
  {
    id: 'coolcat-9909',
    name: 'Cool Cats #9909',
    image: 'https://ipfs.io/ipfs/QmYgwQoEipSfaeEQS8k5ny4K8Fh6ddhLuJHfZmnDNtLCRG',
    price: '0.69 ETH'
  },
  {
    id: 'coolcat-9908',
    name: 'Cool Cats #9908',
    image: 'https://ipfs.io/ipfs/QmdVbSKthcXH29PViY2hpdZyz4HGJk1JfuVf33pYAquAXu',
    price: '0.92 ETH'
  },
  {
    id: 'coolcat-9907',
    name: 'Cool Cats #9907',
    image: 'https://ipfs.io/ipfs/QmZ9K6naSsL3WTQWxWxJiLAMU6VeVHa5XUwPrVQi5VYPea',
    price: '0.55 ETH'
  },
  {
    id: 'coolcat-9890',
    name: 'Cool Cats #9890',
    image: 'https://ipfs.io/ipfs/QmZwgM7wZvaE9Yu2o9UaDhCmfFSWZnUdcr6GxbVK1WvqQC',
    price: '0.77 ETH'
  },
  {
    id: 'coolcat-9889',
    name: 'Cool Cats #9889',
    image: 'https://ipfs.io/ipfs/QmURSTGgVZu8NXw5bo5Xggfx5T6AtzK9vTsvepK4ESVHyh',
    price: '0.96 ETH'
  },
  {
    id: 'coolcat-9888',
    name: 'Cool Cats #9888',
    image: 'https://ipfs.io/ipfs/QmT4XKRAA9V8WZDYUAghyr1E29Fiizcbya8nxxK7xtbRMm',
    price: '0.63 ETH'
  },
  {
    id: 'coolcat-9887',
    name: 'Cool Cats #9887',
    image: 'https://ipfs.io/ipfs/QmchRoQbCES99CDHTsVoLZ2zTvjKHeqhtdBwyZoRRADysK',
    price: '0.84 ETH'
  },
  {
    id: 'coolcat-9886',
    name: 'Cool Cats #9886',
    image: 'https://ipfs.io/ipfs/QmRvBE1xiV4YcDPkF6GUdfQmvK1b9AmGCzCdNRr9cXKBQE',
    price: '0.71 ETH'
  },
  {
    id: 'coolcat-9885',
    name: 'Cool Cats #9885',
    image: 'https://ipfs.io/ipfs/QmZkoTN9zpMW7o6ZuaTfUFTErHAvzvnWp3cHoF78DQmnUb',
    price: '0.93 ETH'
  },
  {
    id: 'coolcat-9884',
    name: 'Cool Cats #9884',
    image: 'https://ipfs.io/ipfs/Qmc4cePRYp2exMARdKgAvzmANGHjnpDNbStMxqmL7Guvyb',
    price: '0.56 ETH'
  },
  {
    id: 'coolcat-9883',
    name: 'Cool Cats #9883',
    image: 'https://ipfs.io/ipfs/QmaUj7N62dzdSbPC6gqMutHms1MFo7zAwg4W8Fb8Jyy3az',
    price: '0.79 ETH'
  },
  {
    id: 'coolcat-9882',
    name: 'Cool Cats #9882',
    image: 'https://ipfs.io/ipfs/QmeJ8ouPthrHr8VxbAq4EbEHgNvbw2n4pyxCA6PM9Jpke4',
    price: '0.98 ETH'
  },
  {
    id: 'coolcat-9881',
    name: 'Cool Cats #9881',
    image: 'https://ipfs.io/ipfs/QmQLHtkPua4VnHL55kHpckKxxcMpxBFguQNaGNjJDMXg71',
    price: '0.65 ETH'
  },
  {
    id: 'coolcat-9880',
    name: 'Cool Cats #9880',
    image: 'https://ipfs.io/ipfs/QmcTgFetoUfKZPggfDS58QDkwU4Z2yEGLKpqaUczdAJCay',
    price: '0.87 ETH'
  },
  {
    id: 'coolcat-9879',
    name: 'Cool Cats #9879',
    image: 'https://ipfs.io/ipfs/QmTy4ofnLvLgTZ9EGLeKLTSYfwC7HoHhQvNbevgrgAsJWB',
    price: '0.74 ETH'
  },
  {
    id: 'coolcat-9906',
    name: 'Cool Cats #9906',
    image: 'https://ipfs.io/ipfs/QmYW21SyVe8y4EkhpDMqh9cKRmYtSMvfLsMFztXm6upQnF',
    price: '0.91 ETH'
  },
  {
    id: 'coolcat-9858',
    name: 'Cool Cats #9858',
    image: 'https://ipfs.io/ipfs/QmaStCwAq5BFqjePbcxWBRgjvVU2DStddSRFVPcsFLLU58',
    price: '0.59 ETH'
  },
  {
    id: 'coolcat-9873',
    name: 'Cool Cats #9873',
    image: 'https://ipfs.io/ipfs/QmZ8G4464rd97bgk6A26ke3M8RjEBkzqF8NPyKmqwysK5c',
    price: '0.82 ETH'
  },
  {
    id: 'coolcat-9878',
    name: 'Cool Cats #9878',
    image: 'https://ipfs.io/ipfs/QmT1XtRUYMbRXKfF8emWcUkKU9YFX56CabBrFFaXja6azC',
    price: '0.68 ETH'
  },
  {
    id: 'coolcat-9905',
    name: 'Cool Cats #9905',
    image: 'https://ipfs.io/ipfs/QmfRhfAdDJNuLaUVdnsq1MzreGuB8sSBS8qTJeHn6TwddM',
    price: '0.90 ETH'
  },
  {
    id: 'coolcat-9894',
    name: 'Cool Cats #9894',
    image: 'https://ipfs.io/ipfs/QmQFJsWBiQkCZe8UPSzg2NwQi3JxixSf727Hv7Veouzp8r',
    price: '0.57 ETH'
  },
  {
    id: 'coolcat-9857',
    name: 'Cool Cats #9857',
    image: 'https://ipfs.io/ipfs/QmRjqS7iavUDW5NwSYKRcw6BE9zq3MyZAvQXZ3pTafY3sw',
    price: '0.80 ETH'
  },
  {
    id: 'coolcat-9868',
    name: 'Cool Cats #9868',
    image: 'https://ipfs.io/ipfs/QmZ6ZfZjG15N6UF7eY3CFaZj5Np4FuCBnbpEaQa1RPZNMj',
    price: '0.66 ETH'
  },
  {
    id: 'coolcat-9877',
    name: 'Cool Cats #9877',
    image: 'https://ipfs.io/ipfs/QmSw3vjMn39ENgeBqGgmryjVCJ9u8e7Ca6VBZ2pDjMnVdr',
    price: '0.88 ETH'
  },
  {
    id: 'coolcat-9872',
    name: 'Cool Cats #9872',
    image: 'https://ipfs.io/ipfs/QmeySjBidrpkvYYWBDcYzbmhqXQkey3dkJNc6GKvyqjrEB',
    price: '0.75 ETH'
  },
  {
    id: 'coolcat-9902',
    name: 'Cool Cats #9902',
    image: 'https://ipfs.io/ipfs/QmWSitYjf1t4MTRA5iwqwVQXx1wW5fzUKRcCAfvpaFWU2s',
    price: '0.97 ETH'
  },
  {
    id: 'coolcat-9898',
    name: 'Cool Cats #9898',
    image: 'https://ipfs.io/ipfs/QmXMzbkQZLawMPQ8BP8bCiG1Er5Gxg5tWMghZh9obNuzWU',
    price: '0.61 ETH'
  },
  {
    id: 'coolcat-9904',
    name: 'Cool Cats #9904',
    image: 'https://ipfs.io/ipfs/QmerD9vVVKPV6XsU7h2N7qcx1oF4TZ1qghie5eJAjTf8vQ',
    price: '0.83 ETH'
  },
  {
    id: 'coolcat-9903',
    name: 'Cool Cats #9903',
    image: 'https://ipfs.io/ipfs/QmdedcwJw2mep8BnFEY5uuCoFA57MyxH8cHbX45dAaPdRW',
    price: '0.70 ETH'
  },
  {
    id: 'coolcat-9856',
    name: 'Cool Cats #9856',
    image: 'https://ipfs.io/ipfs/QmZyCHq2y5qdRATtzRGjAoJqJpEWTz33MqDABs43DLjWAR',
    price: '0.92 ETH'
  },
  {
    id: 'coolcat-9867',
    name: 'Cool Cats #9867',
    image: 'https://ipfs.io/ipfs/Qma34zAkXxVCdoiTgWTw6vVKrhRm6JVzhShJ2zsQnTkN5g',
    price: '0.54 ETH'
  },
  {
    id: 'coolcat-9893',
    name: 'Cool Cats #9893',
    image: 'https://ipfs.io/ipfs/QmecYdKvg6pWK6PPemUYUnJ7uAdGSNUHbu3Xfog7zQbwkD',
    price: '0.76 ETH'
  },
  {
    id: 'coolcat-9876',
    name: 'Cool Cats #9876',
    image: 'https://ipfs.io/ipfs/QmX86ZFXwz1NR8NvaPDg3rcc8iuYpN1kpYB1Q29PaYWKmM',
    price: '1.00 ETH'
  },
  {
    id: 'coolcat-9871',
    name: 'Cool Cats #9871',
    image: 'https://ipfs.io/ipfs/QmRULgdBh9G3T46uuR2AtVxZKmTmDXeUazYMNcKyaWHWJM',
    price: '0.64 ETH'
  },
  {
    id: 'coolcat-9899',
    name: 'Cool Cats #9899',
    image: 'https://ipfs.io/ipfs/QmQuygDVypQ8dnuRayBGVxnB4b1EUDESZaugxido2QNKKk',
    price: '0.86 ETH'
  },
  {
    id: 'coolcat-9901',
    name: 'Cool Cats #9901',
    image: 'https://ipfs.io/ipfs/QmWESPYdg8cST3vXVZ9SWCe7nnbkThfrMaG5Yf6fvwDPEs',
    price: '0.73 ETH'
  },
  {
    id: 'coolcat-9900',
    name: 'Cool Cats #9900',
    image: 'https://ipfs.io/ipfs/QmVejEABRh6DECHFV6eT8AMZ9p8brsnd5ATD8mWLerPUYT',
    price: '0.95 ETH'
  },
  {
    id: 'coolcat-9897',
    name: 'Cool Cats #9897',
    image: 'https://ipfs.io/ipfs/QmX7bgawnjZwnB6ZbGNGeUFMHoCjyhqE5wHbtsSQgXmRnF',
    price: '0.60 ETH'
  },
  {
    id: 'coolcat-9896',
    name: 'Cool Cats #9896',
    image: 'https://ipfs.io/ipfs/QmdN47n4yPc6SAmDV5y5fxafB2KApXBehnt1yhzMM9HxPJ',
    price: '0.82 ETH'
  },
  {
    id: 'coolcat-9855',
    name: 'Cool Cats #9855',
    image: 'https://ipfs.io/ipfs/QmPtSaXgaCaz3aWMPTZtTKowkZcHZHGh3Jm7qYxtMxCRxr',
    price: '0.69 ETH'
  },
  {
    id: 'coolcat-9866',
    name: 'Cool Cats #9866',
    image: 'https://ipfs.io/ipfs/QmZ7oEk1n8KMBv54cJRq48iFDwLLDt9EDVkEV7VNC1LzPh',
    price: '0.91 ETH'
  },
  {
    id: 'coolcat-9892',
    name: 'Cool Cats #9892',
    image: 'https://ipfs.io/ipfs/QmZwSnZLAsq62KZz5gYfHS9ZVrdYeEFmNQxiq92vsrV8KQ',
    price: '0.48 ETH'
  }



];